import { Icon } from "@design-system/Icon/Icon";
import { Tag } from "@design-system/Tag/Tag";

import { ValueComponentProps } from "../../../Select";

type Props = ValueComponentProps & {
  onRemove?: (value: string) => void;
};

export const TagValue = ({ value, options, onRemove }: Props) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the select dropdown
    onRemove?.(value);
  };

  return (
    <Tag
      text={options.find((o) => o.id === value)?.label}
      maxWidth={256}
      color="secondary"
      right={
        onRemove && (
          <button
            type="button"
            onClick={handleRemove}
            style={{
              background: "none",
              border: "none",
              padding: "0",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              opacity: 0.7,
              marginLeft: "4px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "0.7";
            }}
          >
            <Icon icon="faXmark" size="xs" />
          </button>
        )
      }
    />
  );
};
